<template>
  <div class="box">
    <div class="main-content">
      <!-- 教材目录部分开始 -->
      <div class="classTimesList">
        <div v-for="(item, index) in catalogueList" :key="index">
          <div class="classTimesList-title-box flex align">
            <div class="classTimesList-block"></div>
            <div class="classTimesList-title">{{ item.name }}</div>
          </div>
          <div @click="selectCatalogue(index, index1)" :class="currentCatalogueIdx == index && currentCatalogueIdx1 == index1 ? 'allClasses' : 'classList'" v-for="(item, index1) in item.items" :key="index1">
            <div class="classList-circle"></div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- 教材目录部分结束 -->
      <!-- AR图片列表部分开始 -->
      <div class="ARList">
        <el-table style="width: 100%" :data="tableData" border height="100%">
          <el-table-column prop="ARimage" label="AR图片" width="180">
            <template slot-scope="scope">
              <!-- 这里的scope.row是当前行的数据对象 -->
              <el-image fit="cover" style="width: 70px; height: 70px" :src="scope.row.url" :preview-src-list="scope.row.urlList"> </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="created" label="创建日期" width="180"> </el-table-column>
          <el-table-column prop="name" label="关联资源"> </el-table-column>
          <el-table-column prop="num" label="扫描次数"> </el-table-column>
        </el-table>
      </div>
      <!-- AR图片列表部分结束 -->
    </div>
  </div>
</template>

<script>
import { getTextbookCatalogue, getARImageList, getTextbookCatalogueData } from "@/api";
import uploadFile from "@/utils/uploadFile1.js";
import { base64toFile, filetoBase64 } from "@/utils/util.js";
import axios from "axios";
import store from "@/store";
export default {
  data() {
    return {
      identity: "", // 登录身份
      catalogueList: [], // 目录列表
      currentCatalogueIdx: 0, // 当前目录下标
      currentCatalogueIdx1: 0, // 当前模块下标
      currentCatalogueId: 0, // 当前目录id
      currentPaperIdx: 0, // 当前教材纸质下标
      tableData: [],
    };
  },
  created() {
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    // 调用获取教材目录接口
    let params = { book_id: this.$store.state.textbookDetails.id };
    getTextbookCatalogue(params).then((res) => {
      if (res.data.code == 0) {
        this.catalogueList = res.data.datas;
        this.currentCatalogueId = this.catalogueList[0]?.items[this.currentPaperIdx]?.id;
        // 调用获取教材目录数据接口
        let params = {
          book_id: this.$store.state.textbookDetails.id,
          item_id: this.currentCatalogueId,
        };
        getTextbookCatalogueData(params).then((res) => {
          if (res.data.code == 0) {
            this.currentPaperIdx = 0; // 恢复当前教材纸质下标
            this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
            for (let i in res.data.datas) {
              if (res.data.datas[i].exts) {
                for (let j in res.data.datas[i].exts) {
                  if (res.data.datas[i].exts[j]?.ar_images) {
                    res.data.datas[i].exts[j].ar_images[0].urlList = [];
                    res.data.datas[i].exts[j].ar_images[0].urlList.push(res.data.datas[i].exts[j].ar_images[0].url);
                    res.data.datas[i].exts[j].ar_images[0].name = res.data.datas[i].exts[j].name;
                    let dateTimeStr = res.data.datas[i].exts[j].ar_images[0].created;
                    let date = new Date(dateTimeStr);
                    res.data.datas[i].exts[j].ar_images[0].created = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;
                    this.tableData.push(res.data.datas[i].exts[j].ar_images[0]);
                  }
                }
              }
            }
          }
        });
      }
    });
    // let params2 = {};
    // getARImageList(params2).then((res) => {});
  },
  methods: {
    // 选择目录
    selectCatalogue(index, index1) {
      this.tableData = [];
      this.currentCatalogueId = this.catalogueList[index]?.items[index1]?.id; // 获取当前目录id
      console.log(this.currentCatalogueId);
      this.currentCatalogueIdx = index;
      this.currentCatalogueIdx1 = index1;
      // 调用获取教材目录数据接口
      let params = {
        book_id: this.$store.state.textbookDetails.id,
        item_id: this.currentCatalogueId,
      };
      getTextbookCatalogueData(params).then((res) => {
        if (res.data.code == 0) {
          this.currentPaperIdx = 0; // 恢复当前教材纸质下标
          this.textbookCataloguePaperList = res.data.datas; // 获取教材纸质封面数据
          for (let i in res.data.datas) {
            if (res.data.datas[i].exts) {
              for (let j in res.data.datas[i].exts) {
                if (res.data.datas[i].exts[j]?.ar_images) {
                  res.data.datas[i].exts[j].ar_images[0].urlList = [];
                  res.data.datas[i].exts[j].ar_images[0].urlList.push(res.data.datas[i].exts[j].ar_images[0].url);
                  res.data.datas[i].exts[j].ar_images[0].name = res.data.datas[i].exts[j].name;
                  let dateTimeStr = res.data.datas[i].exts[j].ar_images[0].created;
                  let date = new Date(dateTimeStr);
                  res.data.datas[i].exts[j].ar_images[0].created = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;
                  this.tableData.push(res.data.datas[i].exts[j].ar_images[0]);
                }
              }
            }
          }
        }
      });
    },
    // 更改班级
    classHandleChange() {},
  },
};
</script>

<style scoped src="./index.css"></style>
